import {Space} from "antd";
import {SubSettingsFormFields} from "../../../general/settings/sub-settings";
import {SessionPauseSettingFormField} from "./pause-setting";
import {SessionSettingsFormFieldsProps} from "./types";

export function SessionSettingsFormFields({
  formType,
  showUrlRedirect = formType === "edit",
}: SessionSettingsFormFieldsProps & {showUrlRedirect?: boolean}) {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      {formType === "edit" && <SessionPauseSettingFormField />}
      <SubSettingsFormFields
        requestCustomerPhoneNumberLabel="Request customer's phone number"
        hideFromProfileLabel="Hide session from your profile page "
        showUrlRedirect={showUrlRedirect}
      />
    </Space>
  );
}
